<div class="page-header">
  <div>
    <h1>{{ t('EditEbicsTitle') }}</h1>
    <p>{{ t('HubEbicsIntro') }}</p>
  </div>
</div>

@if (error) {
  <p class="message error">{{ error }}</p>
}
@if (success) {
  <p class="message success">{{ success }}</p>
}
@if (loading) {
  <p>{{ t('HubEbicsLoading') }}</p>
}

@if (!loading && ebics) {
  <form class="card ebics-card form-grid" (ngSubmit)="save()">
    <label class="checkbox-label"><input name="active" type="checkbox" [(ngModel)]="ebics.active"> {{ t('EbicsActiveCheckboxLabel') }}</label>
    <div class="form-grid two-columns">
      <label>{{ t('EbicsHostId') }}<input name="hostId" [(ngModel)]="ebics.hostId" placeholder="HOSTID"></label>
      <label>{{ t('EbicsHostUrl') }}<input name="hostUrl" [(ngModel)]="ebics.hostUrl" placeholder="https://ebics.sandbox"></label>
      <label>{{ t('EbicsPartnerId') }}<input name="partnerId" [(ngModel)]="ebics.partnerId" placeholder="11111111"></label>
      <label>{{ t('EbicsUserId') }}<input name="userId" [(ngModel)]="ebics.userId" placeholder="11111111"></label>
      <label>{{ t('EbicsPostMode') }}
        <select name="postMode" [(ngModel)]="ebics.postMode">
          <option value="entry">{{ t('EbicsPostModeEntry') }}</option>
          <option value="statement">{{ t('EbicsPostModeStatement') }}</option>
        </select>
        <small class="field-hint">{{ t('EbicsPostModeHint') }}</small>
      </label>
      <label>{{ t('EbicsApiActionPassword') }}
        <input name="apiActionPassword" type="password" autocomplete="new-password" [(ngModel)]="ebics.apiActionPassword"
               [placeholder]="ebics.apiActionPasswordSet ? t('EbicsApiActionPasswordKeep') : ''">
        <small class="field-hint">{{ t('EbicsApiActionPasswordHint') }}</small>
      </label>
    </div>
    <div class="button-row">
      <button class="primary-button" type="submit"><wa-icon name="floppy"></wa-icon>{{ t('EditEbicsButton') }}</button>
      @if (ebics.bankLetterAvailable) {
        <a class="secondary-button download-link" [href]="ebics.bankLetterUrl" download="ebicsletter.html">{{ t('DownloadEbicsBankLetter') }}</a>
      }
    </div>
  </form>
}
